export enum PortalPageEnum {
    Dashboard,
    Settings,
    Receptionist,
    Business,
    Communications,
    AiConfig,
    PhoneNumbers,
    Bookings,
    Billing,
    AdminInvokeFunction,
    AdminSkill,
    AdminSkillAction,
    AdminSkillActionOutput,
    AdminSkillDomain,
    SkillRunner,
    AiConfigNew,
    CallReview,
    Help,
    DeepKnowledge,
    BusinessCatalog,
    PhoneAi,
    Operations,
    Services
}
